import React, { useState } from 'react';

const PropertySearchBar = ({ onSearch }) => {
  const [id, setId] = useState('');
  const [type, setType] = useState('');
  const [category, setCategory] = useState('');

  const handleSearch = () => {
    onSearch({ id, type, category });
  };

  return (
    <div className="flex mb-4">
      <input
        type="text"
        className="border px-4 py-2 rounded mr-2"
        placeholder="Property ID"
        value={id}
        onChange={(e) => setId(e.target.value)}
      />
      <select
        className="border px-4 py-2 rounded mr-2"
        value={type}
        onChange={(e) => setType(e.target.value)}
      >
        <option value="">All Types</option>
        <option value="House/Villa">House/Villa</option>
        <option value="Apartment">Apartment</option>
        <option value="Open Land">Open Land</option>
        <option value="Flat">Flat</option>
        <option value="Commercial Shop">Commercial Shop</option>
        <option value="Commercial Land">Commercial Land</option>
        <option value="Godown">Godown</option>
      </select>
      <select
        className="border px-4 py-2 rounded mr-2"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      >
        <option value="">All Categories</option>
        <option value="rent">Rent</option>
        <option value="sell">Selling</option>
        <option value="trending">Trending</option>
      </select>
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded"
        onClick={handleSearch}
      >
        Search
      </button>
    </div>
  );
};

export default PropertySearchBar;
